/* eslint-disable */
import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";

export default function DetailsGoogleSheet() {
  const { t } = useTranslation();
  const [buttonText, setButtonText] = useState(t("services.copy_script"));
  const [copySuccess, setCopySuccess] = useState(false);
  const timeoutRef = useRef(null);

  // The script to be copied
  const script = `
var wbook = SpreadsheetApp.openByUrl('https://docs.google.com/spreadsheets/d/1wIodvQkfXKHgx3Mp6Jz08wpQMYtPCfgt9vJg/edit#gid=0')

var sheet = wbook.getSheetByName('Sheet1');

// step 2 
function doPost(e) {
  var action = e.parameter.action;
  if (action == 'addUser') {
    return addUser(e);
  }
}

// step 3 
function addUser(e) {
  var user = JSON.parse(e.postData.contents)
  sheet.appendRow([new Date, user.product, user.name, user.phone, user.state, user.commune, user.address, user.qty, user.price, user.deleveryPrice, user.total, user.options , user.deliveryType, user.sku])
  // step 4 
  return ContentService.createTextOutput("services.Success").setMimeType(ContentService.MimeType.TEXT)
}
  `.trim();

  // Function to copy script to clipboard
  const copyToClipboard = () => {
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Use Clipboard API if available
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(script)
        .then(() => {
          setButtonText(t("services.script_copied"));
          setCopySuccess(true);
          timeoutRef.current = setTimeout(() => {
            setButtonText(t("services.copy_script"));
            setCopySuccess(false);
          }, 3000);
        })
        .catch((err) => {
          console.error(t("services.copy_failed"), err);
          setButtonText(t("services.copy_failed"));
          setCopySuccess(false);
        });
    } else {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = script;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        setButtonText(t("services.script_copied"));
        setCopySuccess(true);
        timeoutRef.current = setTimeout(() => {
          setButtonText(t("services.copy_script"));
          setCopySuccess(false);
        }, 3000);
      } catch (err) {
        console.error(t("services.copy_failed"), err);
        setButtonText(t("services.copy_failed"));
        setCopySuccess(false);
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <div className="dark:!bg-[#181819] min-h-[420px] h-fit" dir={t("services.direction")}>
      <section className="relative max-w-screen-xl px-4 md:px-8 h-fit mt-5 pt-0">
        <div className="flex flex-col md:flex-row gap-6">
          {/* Left Section: Description and Features */}
          <div className="flex-1">
            <h3 className="text-2xl font-bold text-gray-800 dark:!text-gray-200 mb-4">
              {t("services.google_sheet_integration_title")}
              <span className="text-[#9e68ba] dark:!text-[#b48acb]">
                {t("services.google_sheet_integration_highlight")}
              </span>
            </h3>
            <p className="text-gray-600 dark:!text-gray-400 mb-6 leading-relaxed">
              {t("services.google_sheet_description")}
            </p>
            <div className="bg-[#fcf6ff] dark:!bg-[#2a2a2a] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-4">
              <h4 className="font-medium text-[#9e68ba] dark:!text-[#b48acb] mb-2">
                {t("services.key_features")}
              </h4>
              <ul className="space-y-2 text-gray-700 dark:!text-gray-300">
                {t("services.google_sheet_features", { returnObjects: true }).map(
                  (feature, index) => (
                    <li key={index} className="flex items-center">
                      <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                      {feature}
                    </li>
                  )
                )}
              </ul>
            </div>
            <a
              className="inline-flex items-center px-4 py-2 text-[#9e68ba] dark:!text-[#b48acb] bg-[#fcf6ff] dark:!bg-[#2a2a2a] rounded-lg font-medium transition-colors hover:bg-[#faf1ff] dark:hover:!bg-[#3c3a3d]"
              href="https://www.youtube.com/embed/P0a5VUYVF8Q?si=1zOvro7jMw5zrSZ2"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("services.watch_integration_video")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                <path
                  fillRule="evenodd"
                  d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                  clipRule="evenodd"
                />
              </svg>
              {t("services.watch_integration_video")}
            </a>
          </div>

          {/* Right Section: YouTube Video */}
          <div className="flex-1 mx-auto sm:w-9/12 lg:w-auto">
            <iframe
              className="w-full h-64 rounded-2xl"
              src="https://www.youtube.com/embed/P0a5VUYVF8Q?si=1zOvro7jMw5zrSZ2"
              title={t("services.youtube_video_title")}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>

      {/* Script Copy Section */}
      <div className="bg-blue-50 dark:!bg-[#181819] rounded-xl p-3 mx-2 border border-blue-100 dark:!border-[#3c3a3d] mb-6">
        <div className="max-w-screen-xl mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <h3 className="text-blue-800 dark:!text-blue-400 text-xl font-bold mb-3 md:mb-0">
              {t("services.script_used_in_video")}
            </h3>
            <button
              onClick={copyToClipboard}
              className={`px-6 py-2.5 font-medium rounded-lg transition-colors ${copySuccess
                  ? "bg-green-600 text-white"
                  : "bg-blue-800 hover:bg-blue-900 text-white"
                }`}
              aria-label={buttonText}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </div>

  );
}